var map = {
	"./pc-module-standard-1.vue": 70905,
	"./pc-module-standard-2.vue": 67883,
	"./pc-module-standard-3.vue": 5907,
	"./pc-module-standard-4.vue": 86132,
	"./pc-module-standard-5.vue": 34250,
	"./pc-module-standard-6.vue": 47794,
	"./pc-module-standard-7.vue": 28142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72644;